module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("ABBREVIATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("ASEA")]), _vm._v(" Allmanna Svenska Elektriska Aktiebolaget")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("ASLEF")]), _vm._v(" Association of Locomotive Engineers and Firemen")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("BBC")]), _vm._v(" British Broadcasting Corporation")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("BEF")]), _vm._v(" British Expeditionary Force")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("BFB")]), _vm._v(" Bulleid-Firth-Brown")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("BRB")]), _vm._v(" British Railways Board")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("BTC")]), _vm._v(" British Transport Commission")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("BTH")]), _vm._v(" British Thomson-Houston Company")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("CEB")]), _vm._v(" Central Electricity Board")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("CLESC")]), _vm._v(" County of London Electricity Supply Company")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("CLR")]), _vm._v(" Central London Railway")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("DAB")]), _vm._v(" delayed action bomb")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("EMU")]), _vm._v(" Electric Multiple Unit")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("GER")]), _vm._v(" Great Eastern Railway")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("GNR")]), _vm._v(" Great Northern Railway")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("GPO")]), _vm._v(" General Post Office")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("GWR")]), _vm._v(" Great Western Railway")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("HV")]), _vm._v(" high voltage")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("Hz")]), _vm._v(" hertz")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("kW")]), _vm._v(" kilowatt")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("LBSCR")]), _vm._v(" London, Brighton and South Coast Railway")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("LCC")]), _vm._v(" London County Council")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("LCDR")]), _vm._v(" London, Chatham and Dover Railway")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("LESC")]), _vm._v(" London Electricity Supply Company")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("LIRR")]), _vm._v(" Long Island Railroad")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("LMS(R)")]), _vm._v(" London Midland and Scottish Railway")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("LNER")]), _vm._v(" London and North Eastern Railway")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("LNWR")]), _vm._v(" London and North Western Railway")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("LPTB")]), _vm._v(" London Passenger Transport Board")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("LSWR")]), _vm._v(" London and South Western Railway")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("LV")]), _vm._v(" low voltage")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("LYR")]), _vm._v(" Lancashire and Yorkshire Railway")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("M&EE")]), _vm._v(" Mechanical and Electrical Engineering subcommittee")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("MDR")]), _vm._v(" Metropolitan District Railway")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("MER")]), _vm._v(" Manx Electric Railway")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("MP")]), _vm._v(" Member of Parliament")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("NER")]), _vm._v(" North Eastern Railway")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("NHS")]), _vm._v(" National Health Service")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("REC")]), _vm._v(" Railway Executive Committee")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("RFC")]), _vm._v(" Royal Flying Corps")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("RNAS")]), _vm._v(" Royal Naval Air Service")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("RNVR")]), _vm._v(" Royal Naval Volunteer Reserve")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("SCADA")]), _vm._v(" supervisory control and data acquisition")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("SECR")]), _vm._v(" South Eastern and Chatham Railway")]), _vm._v(" "), _c('p', {
    staticClass: "tababb"
  }, [_c('span', {
    staticClass: "tababb01"
  }, [_vm._v("V")]), _vm._v(" Volt(s)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7650f82a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Abbreviations.vue
// module id = 75
// module chunks = 0